import React from 'react';
// eslint-disable-next-line import/no-unresolved
import getSymbolFromCurrency from 'currency-symbol-map';
import PropTypes from 'prop-types';

import Button from '@marvelapp/marvel-ui/button';
import DiscountPrice from '../DiscountPrice';
import PlanBox from '../PlanBox';
import PlanFeatureList from '../PlanFeatureList';

import styles from './PlanCard.css';
import { BILLING_CYCLE_YEARLY } from '../constants/plans';

function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export default function PlanCard({
  availableFeatures,
  billingCycle,
  CTAText,
  handleCTAClick,
  isCurrentPlan,
  isDowngradeToFree,
  monthlyPrice,
  priceBeforeDiscount,
  showDiscountPrice,
  subTitle,
  title,
  yearlyPrice,
  yearlyPricePerMonth,
  currency,
}) {
  const pricePerMonth = Math.ceil(
    billingCycle === BILLING_CYCLE_YEARLY ? yearlyPricePerMonth : monthlyPrice
  );
  const currencySymbol = getSymbolFromCurrency(currency) || '$';
  return (
    <div>
      <PlanBox space="m" isCurrent={isCurrentPlan}>
        <div className={styles.card}>
          <div>
            <div className={styles.header}>
              <div className={styles.name}>{title}</div>
              <div className={styles.description}>{subTitle}</div>
            </div>

            <div className={styles.pricing}>
              <div className={styles.monthlyPrice}>
                <span className="fontWeight-7">
                  {currencySymbol}
                  {numberWithCommas(pricePerMonth)}
                </span>{' '}
                <span className="fontWeight-3">/ month</span>
                {}
              </div>
              {billingCycle === BILLING_CYCLE_YEARLY && pricePerMonth > 0 && (
                <div className={styles.billingText}>billed yearly</div>
              )}
              {!isCurrentPlan && showDiscountPrice && (
                <DiscountPrice
                  yearlyPrice={numberWithCommas(Math.ceil(yearlyPrice))}
                  priceBeforeDiscount={priceBeforeDiscount}
                />
              )}
            </div>
          </div>
          <div>
            <Button
              size="medium"
              kind="flat"
              shape="rounded"
              background="blue"
              hoverColor="blue"
              onClick={handleCTAClick}
              isSad={isDowngradeToFree}
              isDisabled={isCurrentPlan}
            >
              {CTAText}
            </Button>
          </div>
        </div>
      </PlanBox>
      <div className={styles.features}>
        <PlanFeatureList features={availableFeatures} />
      </div>
    </div>
  );
}

PlanCard.propTypes = {
  availableFeatures: PropTypes.array.isRequired,
  billingCycle: PropTypes.string,
  CTAText: PropTypes.string.isRequired,
  handleCTAClick: PropTypes.func.isRequired,
  isCurrentPlan: PropTypes.bool.isRequired,
  isDowngradeToFree: PropTypes.bool.isRequired,
  monthlyPrice: PropTypes.number,
  priceBeforeDiscount: PropTypes.number,
  showDiscountPrice: PropTypes.bool,
  subTitle: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  yearlyPrice: PropTypes.number,
  yearlyPricePerMonth: PropTypes.number.isRequired,
  currency: PropTypes.number.isRequired,
};

PlanCard.defaultProps = {
  monthlyPrice: 0,
};



// WEBPACK FOOTER //
// ./src/components/modules/Pricing/PlanCard/index.js